export const getNaverMaps = () => {
  if (!window) throw new Error('window is not defined');
  if (!window.naver) throw new Error('window.naver is not defined');
  if (!window.naver.maps) throw new Error('window.naver.maps is not defined');
  return window.naver.maps;
};

export default { getNaverMaps };
